/**
 * Created by Tw93 on 2016/10/29.
 */

export const CHECKED = "//gw.alicdn.com/tfs/TB1UT3VpgMPMeJjy1XdXXasrXXa-42-42.png";
export const UN_CHECKED = "//gw.alicdn.com/tfs/TB1hE3VpgMPMeJjy1XdXXasrXXa-42-42.png";



// WEBPACK FOOTER //
// ./packages/wxc-dialog/type.js